module.exports = __webpack_public_path__ + "assets/img/26b4a13637649ab975ec6c9cdbd090c1.svg";